import { actions } from '../../actions';

/**
 * This list of messages for handling success notifications
 *
 */
export const messages = {
  [actions.itemAddFetch.success.type]: 'O produto {productCode} foi adicionado com sucesso.',
  [actions.itemUpdateFetch.success.type]: 'O produto foi atualizado com sucesso.',
  [actions.itemDeleteFetch.success.type]: 'O produto foi removido com sucesso.',
};
